module.exports = __webpack_public_path__ + "static/img/vote_share_bg.ce19b74.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/vote/vote_share_bg.png
// module id = s6zy
// module chunks = 1